import { SUBSCRIPTION_PERIOD } from '../utils/constants'
import makeRequest from './apiConfig'

const paymentEndpoints = {
  createPayment: '/api/orders/create',
  getPaymentStatus: '/api/orders/status',
}

export const createPayment = async productName => {
  try {
    const response = await makeRequest({
      method: 'POST',
      endpoint: paymentEndpoints.createPayment,
      body: {
        productName: productName,
        ...(productName === SUBSCRIPTION_PERIOD
          ? { cloud_payment: true }
          : { stars: true, app_id: window.APP_ID }),
      },
    })
    return response
  } catch (error) {
    console.error('Failed to create payment', error)
    throw error
  }
}

export const getPaymentStatus = async hash => {
  try {
    const response = await makeRequest({
      method: 'GET',
      endpoint: `${paymentEndpoints.getPaymentStatus}?order=${hash}`,
    })

    return response
  } catch (error) {
    console.error('Failed to get payment status:', error)
    throw error
  }
}
